import { jwtDecode } from 'jwt-decode';

export const saveLoginSession = (data, storage = localStorage, now = Date.now()) => {
  const token = data?.token;
  if (typeof token !== 'string' || !token) {
    throw new Error('Login did not return a valid token.');
  }

  const decoded = jwtDecode(token);
  // Validate the JWT's expiry when available, but preserve response metadata.
  const expiry = decoded.exp ?? data.tokenExpiry ?? decoded.tokenExpiry;
  let expiresAt;
  if (expiry !== undefined && expiry !== null) {
    expiresAt = typeof expiry === 'number' || /^\d+(\.\d+)?$/.test(expiry)
      ? Number(expiry) * 1000
      : Date.parse(expiry);
    if (!Number.isFinite(expiresAt)) {
      throw new Error('Login returned an invalid token expiry.');
    }
    if (expiresAt <= now) {
      throw new Error('Login returned an expired token. Please log in again.');
    }
  }

  storage.setItem('token', token);
  if (data.tokenExpiry !== undefined && data.tokenExpiry !== null) {
    storage.setItem('tokenExpiry', String(data.tokenExpiry));
  } else if (expiresAt !== undefined) {
    storage.setItem('tokenExpiry', new Date(expiresAt).toISOString());
  } else {
    storage.removeItem('tokenExpiry');
  }
  return token;
};
